<template>
  <v-row class="menu-items" v-if="isOpen && this.title == 'Descubre' && $mq !== 'mobile'" style="background-color: white">
    <v-col class="colItems col-7">
      <v-row class="elementoLista">
        <v-hover v-slot="{ hover }" class="hovlist">
          <v-card :class="{ 'bg-green': hover }" width="100%">
            <a :href="rutaLugares">
              <button class="header_link">LUGARES</button>
            </a>
          </v-card>
        </v-hover>
      </v-row>
      <v-row class="elementoLista">
        <v-hover v-slot="{ hover }" class="hovlist">
          <v-card :class="{ 'bg-green': hover }" width="100%">
            <a :href="rutaMapaInt">
              <button class="header_link">MAPA INTERACTIVO</button>
            </a>
          </v-card>
        </v-hover>
      </v-row>
      <v-row class="elementoLista">
        <v-hover v-slot="{ hover }" class="hovlist">
          <v-card :class="{ 'bg-green': hover }" width="100%">
            <a :href="rutaPdi">
              <button class="header_link">PUNTOS DE INTERÉS</button>
            </a>
          </v-card>
        </v-hover>
      </v-row>
      <v-row class="elementoLista">
        <v-hover v-slot="{ hover }" class="hovlist">
          <v-card :class="{ 'bg-green': hover }" width="100%">
            <a :href="rutaRutas">
              <button class="header_link">RUTAS</button>
            </a>
          </v-card>
        </v-hover>
      </v-row>
    </v-col>
  </v-row>
  <v-row class="menu-items" v-else-if="isOpen && this.title == 'Disfruta' && $mq !== 'mobile'"
    style="background-color: white">
    <v-col class="colItems col-4">
      <v-row class="elementoLista">
        <v-hover v-slot="{ hover }" class="hovlist">
          <v-card :class="{ 'bg-green': hover }" width="100%">
            <a :href="rutaCallejeros">
              <button class="header_link">CALLEJEROS</button>
            </a>
          </v-card>
        </v-hover>
      </v-row>
      <v-row class="elementoLista">
        <v-hover v-slot="{ hover }" class="hovlist">
          <v-card :class="{ 'bg-green': hover }" width="100%">
            <a :href="rutaCuriosidades">
              <button class="header_link">CURIOSIDADES</button>
            </a>
          </v-card>
        </v-hover>
      </v-row>
      <v-row class="elementoLista">
        <v-hover v-slot="{ hover }" class="hovlist">
          <v-card :class="{ 'bg-green': hover }" width="100%">
            <a :href="rutaDescargaInformacion">
              <button class="header_link">DESCARGA INFORMACIÓN</button>
            </a>
          </v-card>
        </v-hover>
      </v-row>
      <v-row class="elementoLista">
        <v-hover v-slot="{ hover }" class="hovlist">
          <v-card :class="{ 'bg-green': hover }" width="100%">
            <a :href="rutaEnlacesInteres">
              <button class="header_link">ENLACES DE INTERÉS</button>
            </a>
          </v-card>
        </v-hover>
      </v-row>
      <v-row class="elementoLista">
        <v-hover v-slot="{ hover }" class="hovlist">
          <v-card :class="{ 'bg-green': hover }" width="100%">
            <a :href="rutaEventos">
              <button class="header_link">EVENTOS</button>
            </a>
          </v-card>
        </v-hover>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
/* eslint-disable */
export default {
  name: "DropDown",
  props: {
    items: Array,
    title: String,
  },
  data() {
    return {
      isOpen: false,
      test: false,
      subitems: [],
      imgUrl: "",
      showCol: false,
      dimension: "14em",
      segundaColAbierta: false,
      buttonCol: false,
  
      // Rutas Descubre
      rutaLugares: "/lugares",
      rutaNoticia: "/noticias",
      rutaMapaInt: "/mapa",
      rutaPdi: "/pdi",
      rutaRutas: "/rutas",

      // Rutas Disfruta
      rutaCallejeros: "/callejeros",
      rutaCuriosidades: "/curiosidades",
      rutaDescargaInformacion: "/descarga",
      rutaEnlacesInteres: "/enlaces",
      rutaEventos: "/eventos",
    };
  },
  methods: {
    cambiarCol() {
      this.segundaColAbierta = !this.segundaColAbierta;
    },
    getImgDimension() {
      return this.dimension;
    },
    updateImageUrl(item) {
      var url = item.data.attributes.url;
      this.imgUrl = this.$baseStrapiUrl + url;
    },
    getImgUrl() {
      return this.imgUrl;
    },
    mostrar(item) {
      if (this.test == true) this.test = false;
      if (item.submenu.length == 0) {
        window.location.href = item.link;
      } else {
        this.subitems = item.submenu;
        this.test = !this.test;
        var padre = 0;
        if (this.title == "Disfruta") padre = this.$parent.counterDisf;
        else if (this.title == "Descubre") padre = this.$parent.counterDesc;
        else padre = this.$parent.counterDesc;
        if (padre < this.subitems.length) this.$parent.modMargin(this.subitems.length);
        else this.$parent.modMargin(padre);
      }
      this.segundaColAbierta = !this.segundaColAbierta;
    },
  },
};
</script>

<style>
#showCol {
  display: none;
}

#colSubItems:hover+#showCol {
  display: block;
}

#colSubItems:hover~#hideCol {
  display: none;
}

.header_link {
  font-size: x-large;
  font-family: "Amatic SC", cursive;
  text-align: center;
  color: black;
}

.header_link:hover {
  background-color: #d6deab;
}

.colItems {
  width: 100%;
  height: auto;
}

.colImg {
  display: flex;
  align-items: center;
  justify-content: center;
}

nav .menu-item svg {
  width: 10px;
  margin-left: 10px;
}

.row .hovlist {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-green {
  background-color: #d6deab !important;
}

.elementoLista {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 40%;
  margin: 1px;
  padding: px;
  border-style: solid;
  border-color: #d6deab;
  font-size: 1.5em;
  opacity: inherit;
}

@media screen and (max-width: 873px) {
  .elementoLista {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    margin: 1px;
    padding: 10px;
    font-size: 1em;
    opacity: inherit;
  }
}

a:link,
a:visited {
  color: #1976d2;
  text-decoration: none;
}

a:hover {
  color: #1976d2;
}
</style>